import React from 'react';

import HeaderDropdownLinks from './menu/index';
import s from './styles.module.scss';

import type { IDropdownLinks } from '../types';

interface IProps {
  links: IDropdownLinks[];
  showNavigation: boolean;
}

const NavSection: React.FC<IProps> = ({ links, showNavigation }) => {
  return (
    <nav>
      <ul className={s.links}>
        {showNavigation &&
          links.map((link) => (
            <HeaderDropdownLinks key={link.label} data={link} />
          ))}
      </ul>
    </nav>
  );
};

export default NavSection;
